<template>
  <transition name="fade">
    <div class="position-relative z-index-1038" :class="{'z-index-1041':data}">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-12 position-relative">
                <div class="">
                  <div class="w-100 py-2 px-2" 
                    @click="onBack('handlePopupFilter', false)"
                    style="height: 100vh;background-color: #00000099">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
 <script>
  export default{
    props: ['poppup_active','data'],
    components:{
    },
    data(){
      return{
      }
    },
    methods:{
      onBack(type,data){
        this.$emit(type,data)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/PopUpBackgroundDesktop.vue